/**
 * A titled chunk of narrated reasoning parsed from markdown-style bold headers.
 */
export interface NarratedReasoningSection {
  title: string;
  content: string;
}

/**
 * Splits narrated agent reasoning into display sections headed by `**Title**`
 * markers, preserving any text before the first marker as an untitled preamble.
 */
export function parseNarratedReasoningSections(text: string): NarratedReasoningSection[] {
  const headerRegex = /\*\*(.+?)\*\*/g;
  const headers: { title: string; start: number; end: number }[] = [];
  let match = headerRegex.exec(text);

  while (match) {
    headers.push({
      title: match[1].trim(),
      start: match.index,
      end: match.index + match[0].length,
    });
    match = headerRegex.exec(text);
  }

  if (headers.length === 0) return [];

  const sections: NarratedReasoningSection[] = [];
  const preamble = text.slice(0, headers[0].start).trim();
  if (preamble) {
    sections.push({ title: "", content: preamble });
  }

  for (let index = 0; index < headers.length; index += 1) {
    const contentStart = headers[index].end;
    const contentEnd = index + 1 < headers.length ? headers[index + 1].start : text.length;
    const content = text
      .slice(contentStart, contentEnd)
      .replace(/^\s*\n/, "")
      .trim();
    sections.push({
      title: headers[index].title,
      content,
    });
  }

  return sections;
}
